import { render, staticRenderFns } from "./SeriesCopy.vue?vue&type=template&id=64ba3339&"
import script from "./SeriesCopy.vue?vue&type=script&lang=js&"
export * from "./SeriesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports